import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useHttpClient } from '../../../../utils/clients/rest-client';
import { ConfigureBinarySensorRequest, BinarySensorConfigureData } from '../../types/openapi/openapi-types';

export const useBinarySensorConfigure = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<AxiosResponse<BinarySensorConfigureData>, AxiosError<void>, ConfigureBinarySensorRequest>(
    ['binarySensor-configure'],
    async (body) => await httpClient.binarySensor.binarySensorConfigure(body),
    {
      onError: (error) => handleRestErrors(error),
    },
  );
};
